import {
  Box,
  Button,
  Radio,
  Group,
  Drawer,
  Select,
  TextInput,
  Textarea,
  Tooltip,
  Text,
  Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect, useRef, useCallback, useMemo } from "react";

import swal from "sweetalert";

import { DateInput, DatePickerInput } from "@mantine/dates";

import moment from "moment";
import { useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { IconChevronDown, IconFile } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { AddMedication, EditMedication } from "../../services/patient";
import { scanMedicationLabel } from "../../services/medication";
import { requestSmsUpload } from "../../services/smsUpload";
import { decrypt, defaultImage, showError } from "../../utils";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import useStyles from "./style";
import { Dropzone } from "@mantine/dropzone";
import ScheduleMenu from "./ScheduleMenu";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import ConfirmationModal from "../ConfirmationModal";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import { updateDiscontinue } from "../../services";
import VersionUpdateModal from "../ConfirmationModal/VersionUpdateModal";
import EyeIconSvg from "../Svgs/EyeIconSvg";
import { FiCalendar } from "react-icons/fi";
import { LuX, LuCheck } from "react-icons/lu";

const bgColor = "#fff";

const AddNewMedicationModal = ({
  opened,
  onclose,
  userId,
  selectedClient,
  data,
  isPreview,
  currentPage,
  tabName,
  getAllPatients,
  setShowClientForm,
  getClientData,
  closeAskMedicalModal,
  form2,
  pendingSubmission,
}) => {
  const { classes, cx } = useStyles();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const client = useSelector((state) => state.mar.selectedClient);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("scheduled");
  const [files, setFiles] = useState([]);
  const [scanState, setScanState] = useState("idle"); // 'idle' | 'scanning' | 'done'
  const [scannedFields, setScannedFields] = useState(new Map());
  const [scanImage, setScanImage] = useState(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [facingMode, setFacingMode] = useState("environment");
  const [smsPhone, setSmsPhone] = useState("+1");
  const [smsNote, setSmsNote] = useState("");
  const [smsSending, setSmsSending] = useState(false);
  const [smsSent, setSmsSent] = useState(false);
  const [smsPopoverOpen, setSmsPopoverOpen] = useState(false);
  const [smsSecondsLeft, setSmsSecondsLeft] = useState(0);
  const [smsImageReceived, setSmsImageReceived] = useState(false);
  const scanInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  // getUserMedia + <video> is unreliable in iOS Safari; use native file capture instead.
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const { profile } = useSelector((state) => state.profile);
  const businessTimezone = profile?.business?.timezone || "UTC";
  const [frequencyData, setFrequencyData] = useState([
    "QAM",
    "QPM",
    "Q4HR",
    "Q2HR",
    "Q6HR",
    "Q8HR",
    "Q12HR",
    "AC",
    "PC",
    "BID",
    "TID",
    "QID",
    "STAT",
    "QOD",
    "Noon",
    "QD",
    "5x/day",
    "6x/day",
    "AC",
    "AC HS",
    "AC breakfast",
    "AC breakfast/dinner",
    "AC breakfast/lunch",
    "AC dinner",
    "AC lunch",
    "AC lunch/dinner",
    "BID",
    "BID AC",
    "BID HS",
    "BID PC",
    "BID w/meals",
    "Daily",
    "Daily AC",
    "Every other day",
    "Every other evening",
    "On call",
    "Once",
    "PC",
    "PC HS",
    "q2h",
    "q2min",
    "q30min",
    "q36hr",
    "q3day",
    "q3h",
    "q3min",
    "q48h",
    "q4h",
    "q5min",
    "q6h",
    "q6min",
    "q72h",
    "q4day",
    "q5day",
    "q7day",
    "q10day",
    "q14day",
    "q21day",
    "q28day",
    "q7min",
    "q8h",
    "q8min",
    "q96hrs",
    "q2week",
    "PC breakfast",
    "PC breakfast/dinner",
    "PC breakfast/lunch",
    "PC dinner",
    "PC lunch",
    "PC lunch/dinner",
    "QID",
    "TID",
    "TID AC",
    "TID HS",
    "TID PC",
    "TID w/meals",
    "Today",
    "UD",
    "Before discharge",
    "p each loose BM",
    "q10min",
    "q12h",
    "q15min",
    "q1h",
    "q1min",
    "q20min",
    "q24h",
    "q3week",
    "q4week",
    "q6week",
    "q2month",
    "q3month",
    "q4month",
    "q6month",
    "qAM",
    "qPM",
    "qAM HS",
    "qAM PM",
    "qHS",
    "qmonth",
    "qweek",
    "qyear",
    "qShift",
    "w/breakfast",
    "w/breakfast/dinner",
    "w/breakfast/lunch",
    "w/dinner",
    "w/lunch",
    "w/lunch/dinner",
    "w/meals",
    "w/meals HS",
    "x1",
    "Daily",
    "Once Weekly",
    "Once Monthly",
  ]);
  const [selectedDays, setSelectedDays] = useState(
    data?.repeatOn || [moment().format("dddd")],
  );
  const [isMedicationCountEnabled, setIsMedicationCountEnabled] =
    useState("yes");

  // RxTerms API state
  const [rxSuggestions, setRxSuggestions] = useState([]);
  const [rxLoading, setRxLoading] = useState(false);
  const [rxShowDropdown, setRxShowDropdown] = useState(false);
  const [rxStrengthOptions, setRxStrengthOptions] = useState([]);
  const rxDebounceRef = useRef(null);
  const rxDropdownRef = useRef(null);

  const parseRouteFromDisplayName = (displayName) => {
    const match = displayName.match(/\(([^)]+)\)/);
    if (!match) return null;
    const inside = match[1].toLowerCase();
    if (inside.includes("oral")) return "Orally";
    if (inside.includes("inject") || inside.includes("injectable"))
      return "Injection";
    if (inside.includes("inhalation") || inside.includes("inhalant"))
      return "Inhalation";
    if (inside.includes("nasal")) return "Nasal";
    if (inside.includes("sublingual")) return "Sublingual";
    if (inside.includes("topical")) return "Topical";
    if (inside.includes("buccal")) return "Buccal";
    if (inside.includes("rectal")) return "Rectal";
    if (inside.includes("vaginal")) return "Vaginal";
    if (inside.includes("subcutaneous")) return "Subcutaneous";
    if (inside.includes("intramuscular")) return "Intramuscular";
    if (inside.includes("cutaneous")) return "Cutaneous";
    if (inside.includes("parenteral")) return "Parenteral";
    return null;
  };

  const parseDoseForm = (text) => {
    const t = text.toLowerCase();
    if (t.includes("tablet") || t.includes(" tab")) return "Tablet";
    if (t.includes("capsule") || t.includes(" cap")) return "Capsule";
    if (t.includes("syrup")) return "Syrup";
    if (t.includes("pill")) return "Pill";
    if (t.includes("liquid")) return "Liquid";
    if (t.includes("solution")) return "Solution";
    if (t.includes("cream")) return "Cream";
    if (t.includes("ointment")) return "Ointment";
    if (t.includes("lotion")) return "Lotion";
    if (t.includes("gel")) return "Gel";
    if (t.includes("gas")) return "Gas";
    if (t.includes("inhalant") || t.includes("inhalation")) return "Inhalant";
    if (t.includes("inject")) return "Injection";
    if (t.includes("suppository")) return "Suppository";
    if (t.includes("lozenge")) return "Lozenge";
    if (t.includes("paste")) return "Paste";
    if (t.includes("patch")) return "Patch";
    if (t.includes("rinse")) return "Rinse";
    if (t.includes("shampoo")) return "Shampoo";
    if (t.includes("drop")) return "Drops";
    if (t.includes("spray")) return "Spray";
    if (t.includes("powder")) return "Powder";
    if (t.includes("cartridge")) return "Injection";
    return null;
  };

  const searchRxTerms = useCallback(async (term) => {
    if (!term || term.length < 2) {
      setRxSuggestions([]);
      setRxShowDropdown(false);
      return;
    }
    setRxLoading(true);
    try {
      const url = `https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(term)}&ef=STRENGTHS_AND_FORMS,RXCUIS,SXDG_RXCUI,DISPLAY_NAME_SYNONYM&maxList=10`;
      const response = await fetch(url);
      const result = await response.json();
      const [total, codes, extraData, displayItems] = result;
      const mapped = (codes || []).map((code, i) => ({
        displayName: code,
        strengthsAndForms: extraData?.STRENGTHS_AND_FORMS?.[i] || [],
        rxcuis: extraData?.RXCUIS?.[i] || [],
        sxdgRxcui: extraData?.SXDG_RXCUI?.[i] || null,
        displayNameSynonym: extraData?.DISPLAY_NAME_SYNONYM?.[i] || [],
      }));
      console.log("RxTerms API — raw response:", result);
      console.log("RxTerms API — total results:", total);
      console.log("RxTerms API — mapped drugs:", mapped);
      setRxSuggestions(mapped);
      setRxShowDropdown(mapped.length > 0);
    } catch (err) {
      console.error("RxTerms API error:", err);
    } finally {
      setRxLoading(false);
    }
  }, []);

  const handleRxInputChange = (value) => {
    form.setFieldValue("medicationName", value);
    setRxStrengthOptions([]);
    form.setFieldValue("strengthAndForm", "");
    if (rxDebounceRef.current) clearTimeout(rxDebounceRef.current);
    rxDebounceRef.current = setTimeout(() => searchRxTerms(value), 400);
  };

  const handleRxSelect = (drug) => {
    console.log("RxTerms — selected drug full data:", drug);
    console.log("  Display Name:", drug.displayName);
    console.log("  Strengths & Forms:", drug.strengthsAndForms);
    console.log("  RxCUIs:", drug.rxcuis);
    console.log("  SXDG RxCUI:", drug.sxdgRxcui);
    console.log("  Synonyms:", drug.displayNameSynonym);
    form.setFieldValue("medicationName", drug.displayName);
    form.setFieldValue("strengthAndForm", "");
    const route = parseRouteFromDisplayName(drug.displayName);
    if (route) form.setFieldValue("ingestionMode", route);
    const doseForm = parseDoseForm(drug.displayName);
    if (doseForm) form.setFieldValue("dosageForm", doseForm);
    setRxStrengthOptions(drug.strengthsAndForms || []);
    setRxShowDropdown(false);
    setRxSuggestions([]);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (rxDropdownRef.current && !rxDropdownRef.current.contains(e.target)) {
        setRxShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [confirmModal, { open: confirmOpen, close: confirmClose }] =
    useDisclosure(false);
  const [
    versionUpdateModal,
    { open: versionUpdateOpen, close: versionUpdateClose },
  ] = useDisclosure(false);

  const handleRadioChange = (event) => {
    const checked = event;
    setIsMedicationCountEnabled(checked);
    if (checked?.toLowerCase() === "no") {
      form.setFieldValue("totalMedicine", "unlimited");
      form.setFieldValue("medicineRemaining", "unlimited");
    } else if (checked?.toLowerCase() === "yes") {
      // Switching back to limited: restore last saved numeric values from DB.
      // If DB had numeric values use them; if DB was also unlimited (first time
      // switching to limited) clear the fields so the user can type new values.
      const lastTotal =
        data?.totalMedicine !== "unlimited" ? data?.totalMedicine : null;
      const lastRemaining =
        data?.medicineRemaining !== "unlimited"
          ? data?.medicineRemaining
          : null;
      form.setFieldValue("totalMedicine", lastTotal ?? null);
      form.setFieldValue("medicineRemaining", lastRemaining ?? null);
    }
  };

  const validation = () => {
    const _validation = {
      isPrescribed: (value) => (value ? null : "Required"),
      isNarcotic: (value) => (value ? null : "Required"),
      medicationName: (value) => (value ? null : "Required"),
      medicationType: (value) => (value ? null : "Required"),
      // dosage: (value) => (value ? null : "Required"),
      // unit: (value) => (value ? null : "Required"),
      // frequency: (value) => (value ? null : "Required"),
      ingestionMode: (value) => (value ? null : "Required"),
      totalMedicine: (value) => (value ? null : "Required"),
      medicationadministered: (value) => (value ? null : "Required"),
      medicationInstruction: (value) => (value ? null : "Required"),
      medicationDate: (value) => (value ? null : "Required"),
      medicineRemaining: (value) => (value ? null : "Required"),
      timeSlots: (value) => (value ? null : "Required"),
    };
    if (data) {
      delete _validation?.medicineRemaining;
    } else if (type === "PRN") {
      delete _validation?.timeSlots;
    }
    return _validation;
  };
  // const _initialValues = {
  //   isPrescribed: "Yes",
  //   isNarcotic: "Yes",
  //   medicationName: "Aleoya",
  //   medicationType: "scheduled",
  //   dosage: 200,
  //   unit: "mg",
  //   frequency: "Q4HR",
  //   ingestionMode: "Buccal",
  //   dosageForm: "Tablet",
  //   totalMedicine: 200,
  //   medicationUse: "qwertyu",
  //   medicationInstruction: "qwerty",
  //   responsibleParty: "Family",
  //   administering: "Family",
  //   medicationDate: new Date("2024/07/28"),
  //   expirationDate: new Date("2024/09/30"),
  //   timeSlots: ["02:00 AM", "08:00 PM"],
  //   medicineRemaining: 180,
  //   medicationadministered: 3,
  //   orderDate: null,
  //   repeatEvery: 1,
  //   repeatType: "week",
  //   repeatOn: [
  //     moment("2024/07/29").format("dddd"),
  //     moment("2024/07/30").format("dddd"),
  //     moment("2024/07/31").format("dddd"),
  //   ],
  //   scheduleType: "custom",
  // };
  const _initialValues = {
    isPrescribed: "",
    isNarcotic: "",
    medicationName: "",
    medicationType: "",
    dosage: "",
    unit: "",
    frequency: "",
    ingestionMode: "",
    dosageForm: "",
    strengthAndForm: "",
    totalMedicine: "",
    // medicationUse: "",
    medicationInstruction: "",
    // responsibleParty: "",
    // administering: "",
    medicationDate: new Date(),
    expirationDate: null,
    timeSlots: [],
    medicineRemaining: "",
    medicationadministered: "",
    orderDate: null,
    repeatEvery: 1,
    repeatType: "day",
    repeatOn: [moment().format("dddd")],
    scheduleType: "daily",
    files: [],
    refillsLeft: "",
    rxNumber: "",
  };
  const form = useForm({
    initialValues: _initialValues,
    validate: validation(),
  });

  // Tracks the last value of `opened` so we can detect the drawer just opening.
  const prevOpenedRef = useRef(opened);
  // Tracks the last pendingSubmission id so we can detect new OCR data arriving while the drawer is open.
  const prevPendingIdRef = useRef(null);
  // Stores the last OCR data received via SMS so Remove doesn't lose it.
  const smsOcrDataRef = useRef(null);

  const applyOcrPrefill = useCallback((ocrData) => {
    if (!ocrData) return;
    const updates = {};

    const fieldMap = {
      medicationName: "medicationName",
      dosage: "dosage",
      unit: "unit",
      frequency: "frequency",
      route: "ingestionMode",
      doseForm: "dosageForm",
      rxNumber: "rxNumber",
      quantity: "totalMedicine",
      instructions: "medicationInstruction",
    };

    Object.entries(fieldMap).forEach(([ocrKey, formKey]) => {
      const entry = ocrData?.[ocrKey];
      if (entry?.value !== null && entry?.value !== undefined && entry?.confidence > 0) {
        updates[formKey] = entry.value;
      }
    });

    if (updates.dosageForm) {
      const raw = String(updates.dosageForm);
      updates.dosageForm = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    }

    const scheduleEntry = ocrData?.scheduleType;
    if (scheduleEntry?.value !== null && scheduleEntry?.value !== undefined && scheduleEntry?.confidence > 0) {
      const raw = String(scheduleEntry.value).toLowerCase();
      updates.medicationType = raw === "prn" ? "PRN" : raw;
    }

    const narcoticEntry = ocrData?.narcoticStatus;
    if (narcoticEntry?.value !== null && narcoticEntry?.value !== undefined && narcoticEntry?.confidence > 0) {
      updates.isNarcotic = narcoticEntry.value ? "Yes" : "No";
    }

    const isPrescribedEntry = ocrData?.isPrescribed;
    if (isPrescribedEntry != null) {
      updates.isPrescribed = isPrescribedEntry.value === false ? "No" : "Yes";
    }

    const timeSlotsEntry = ocrData?.timeSlots;
    if (Array.isArray(timeSlotsEntry?.value) && timeSlotsEntry.value.length > 0 && timeSlotsEntry.confidence > 0) {
      updates.timeSlots = timeSlotsEntry.value.map((t) => {
        const match = String(t).match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!match) return t;
        return `${match[1].padStart(2, "0")}:${match[2]} ${match[3].toUpperCase()}`;
      });
    }

    const adminCountEntry = ocrData?.administrationCount;
    if (adminCountEntry?.value !== null && adminCountEntry?.value !== undefined && adminCountEntry?.confidence > 0) {
      updates.medicationadministered = String(adminCountEntry.value);
    }

    const refillsEntry = ocrData?.refillsCount;
    if (refillsEntry?.value !== null && refillsEntry?.value !== undefined && refillsEntry?.confidence > 0) {
      updates.refillsLeft = String(refillsEntry.value);
    }

    if (Object.keys(updates).length > 0) {
      form.setValues((current) => ({ ...current, ...updates }));
      if (updates.medicationType) setType(updates.medicationType);
    }
  }, [form]);

  useEffect(() => {
    const buildConfidenceMap = (ocrData) => {
      const map = new Map();
      if (!ocrData) return map;
      const fieldMap = {
        medicationName: "medicationName",
        dosage: "dosage",
        unit: "unit",
        frequency: "frequency",
        route: "ingestionMode",
        doseForm: "dosageForm",
        rxNumber: "rxNumber",
        quantity: "totalMedicine",
        instructions: "medicationInstruction",
      };
      Object.entries(fieldMap).forEach(([ocrKey, formKey]) => {
        const entry = ocrData[ocrKey];
        if (entry?.value != null && entry.confidence > 0) map.set(formKey, entry.confidence);
      });
      if (ocrData.scheduleType?.confidence > 0) map.set("medicationType", ocrData.scheduleType.confidence);
      if (ocrData.narcoticStatus?.confidence > 0) map.set("isNarcotic", ocrData.narcoticStatus.confidence);
      if (ocrData.isPrescribed != null) map.set("isPrescribed", ocrData.isPrescribed.confidence ?? 100);
      if (Array.isArray(ocrData.timeSlots?.value) && ocrData.timeSlots.confidence > 0) map.set("timeSlots", ocrData.timeSlots.confidence);
      if (ocrData.administrationCount?.confidence > 0) map.set("medicationadministered", ocrData.administrationCount.confidence);
      if (ocrData.refillsCount?.confidence > 0) map.set("refillsLeft", ocrData.refillsCount.confidence);
      return map;
    };

    const applySocketImages = (images) => {
      if (!Array.isArray(images) || images.length === 0) return;
      const { data, mimetype } = images[0];
      setScanImage(`data:${mimetype};base64,${data}`);
      setScanState("done");
      setSmsImageReceived(true);
    };

    const pending = sessionStorage.getItem("pendingOcrResult");
    if (pending) {
      const parsed = JSON.parse(pending);
      const ocrData = parsed.ocrResults?.[0];
      sessionStorage.removeItem("pendingOcrResult");
      smsOcrDataRef.current = ocrData;
      applyOcrPrefill(ocrData);
      setScannedFields(buildConfidenceMap(ocrData));
      applySocketImages(parsed.images);
    }

    const handler = (e) => {
      const ocrData = e.detail.ocrResults?.[0];
      sessionStorage.removeItem("pendingOcrResult");
      smsOcrDataRef.current = ocrData;
      applyOcrPrefill(ocrData);
      setScannedFields(buildConfidenceMap(ocrData));
      applySocketImages(e.detail.images);
    };
    window.addEventListener("medication-ocr-ready", handler);
    return () => window.removeEventListener("medication-ocr-ready", handler);
  }, [applyOcrPrefill]);

  useEffect(() => {
    const justOpened = opened && !prevOpenedRef.current;
    prevOpenedRef.current = opened;

    if (data) {
      const resolvedMedicationType = (() => {
        if (!data?.medicationType) return "";
        if (Array.isArray(data.medicationType)) {
          return (
            data.medicationType[data.medicationType.length - 1]?.status || ""
          );
        }
        try {
          const parsed = JSON.parse(data.medicationType);
          if (Array.isArray(parsed)) {
            return parsed[parsed.length - 1]?.status || "";
          }
        } catch {}
        return data.medicationType;
      })();
      setType(resolvedMedicationType || "scheduled");

      form.setValues({
        ...data,
        medicationType: resolvedMedicationType,
        medicineRemaining: data?.medicineRemaining,
        ingestionMode: data?.ingestionMethod || data?.ingestionMode,
        medicationDate: data?.medicationDate
          ? new Date(data?.medicationDate)
          : null,
        expirationDate:
          data &&
          isPreview &&
          (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
            ? ""
            : data &&
                (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
              ? ""
              : data?.medicationEndDate && data?.medicationEndDate != "null"
                ? new Date(data?.medicationEndDate)
                : null,
        medicationEndDate:
          data && isPreview && data?.hasExpiryDate == "false"
            ? ""
            : data && data.hasExpiryDate == "false"
              ? ""
              : data?.medicationEndDate && data?.medicationEndDate != "null"
                ? new Date(data?.medicationEndDate)
                : null,
        repeatEvery: Number(data?.repeatEvery || 1),
        orderDate:
          data?.orderDate &&
          data?.orderDate != "null" &&
          data?.orderDate != "undefined"
            ? new Date(data?.orderDate)
            : null,
        files: data?.file || [],
      });
      // setFiles(data?.file || []);

      // FIX 1: Handle file initialization properly from doctorNote URL
      if (data?.doctorNote) {
        // Create a file object from the existing doctor note URL
        const fileName =
          data.doctorNote
            .split("/")
            .pop()
            ?.replace(/%20/g, " ")
            .replace(/%252520/g, " ") || "uploaded-file.pdf";
        const existingFile = {
          path: decodeURIComponent(fileName),
          uploadURL: data.doctorNote,
        };
        setFiles([existingFile]);
      } else {
        setFiles([]);
      }
      if (data?.strengthAndForm) {
        setRxStrengthOptions([data.strengthAndForm]);
      }
      if (
        data?.medicineRemaining == "unlimited" &&
        data?.totalMedicine == "unlimited"
      ) {
        setIsMedicationCountEnabled("no");
      } else {
        setIsMedicationCountEnabled("yes");
      }
    } else if (justOpened) {
      // Drawer just opened in add-mode: reset stale values from a previous edit.
      form.reset();
      setFiles([]);
      setRxStrengthOptions([]);
      setIsMedicationCountEnabled("yes");
      // Pre-fill from OCR data when opened from a pending SMS submission
      if (pendingSubmission?.ocrData) {
        applyOcrPrefill(pendingSubmission.ocrData);
      }
      prevPendingIdRef.current = pendingSubmission?.id ?? null;
    } else if (opened && !data && pendingSubmission?.ocrData && pendingSubmission.id !== prevPendingIdRef.current) {
      console.log("[Modal] OCR fill | pendingSubmission:", pendingSubmission);
      prevPendingIdRef.current = pendingSubmission.id;
      applyOcrPrefill(pendingSubmission.ocrData);
    } else {
      console.log("[Modal] OCR fill skipped | opened:", opened, "data:", !!data, "ocrData:", !!pendingSubmission?.ocrData, "isNew:", pendingSubmission?.id !== prevPendingIdRef.current);
    }
    // Do NOT reset when `data` changes while the drawer is already open —
    // that would wipe OCR-filled values when the user clicks Remove.
  }, [data, opened, pendingSubmission]);

  const reset = () => {
    getClientData?.();
    getAllPatients?.(currentPage, true, tabName);
    setLoading(false);
    resetScan();
    setFiles([]);
    setRxStrengthOptions([]);
    setIsMedicationCountEnabled("yes");
    resetSmsForm();
    onclose();
  };

  const handleDateConverter = (date, timeslot = null) => {
    const currentDate = new Date(date);
    const timeString = timeslot;

    if (timeslot) {
      const [time, modifier] = timeString.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      }
      if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      let newdate = currentDate.setHours(hours, minutes, 0, 0);
      return moment(newdate);
    } else {
      return moment(date);
    }
  };

  const setScheduleDates = (values) => {
    const _format = "YYYY-MM-DD";
    // let _startDate = moment.tz(moment(values?.medicationDate), moment.tz.guess()).tz("UTC");
    let _startDate = moment(values?.medicationDate).startOf("day");

    let _endDate = values?.expirationDate
      ? moment(values?.expirationDate)
      : // : moment(values?.medicationDate).startOf("day");
        moment().endOf("year");
    let _dateRange = [];
    let _currentDate = _startDate.clone();
    let _finalDateWithTimeSlots = [];

    if (values?.scheduleType === "custom") {
      if (values?.repeatType === "day") {
        // For Day
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "day");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      } else if (values?.repeatType === "week") {
        // For Week
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          let days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          let days_dates = Array.from({ length: 7 }, (_, i) =>
            _currentDate
              .clone()
              .startOf("week")
              .add(i, "days")
              .format("MM-DD-YYYY"),
          );

          values?.repeatOn?.map((day) => {
            let index = days?.indexOf(day);
            if (
              index !== -1 &&
              moment(days_dates[index]).isSameOrAfter(_startDate) &&
              moment(days_dates[index]).isSameOrBefore(_endDate)
            ) {
              // _currentDate.format(_format)
              // _dateRange.push(moment(days_dates[index]).toISOString());
              _dateRange.push(moment(days_dates[index]).format(_format));
              // _dateRange.push(moment(days_dates[index]).tz(user?.timeZone).format(_format));
            }
          });
          _currentDate.add(values?.repeatEvery, "week");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots?.forEach((time) => {
            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
            // if (serverFeTimeDiff > 20000) {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff if:", diff)
            // } else {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff else:", diff)

            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + "00:00 AM" , "YYYY-MM-DD hh:mm A").tz("UTC").subtract(Math.abs(diff) , "hours").add(2 , "hours")?.toISOString()
            //   );

            // theory how it will work
            //  we need to cater three timeZones
            //  BE = KHI, FE = Brazil, UTC TimeZone
            //  first of all calculate the difference between BE and FE timezone here = 8 hours
            //  after
            //

            // let currentDate = moment(date, "YYYY-MM-DD").tz(user?.timeZone) // first convert this value to FE Timezone then you have to add/subtract 8 hours BE FE Timezone difference
            // let timeslot;

            // if (serverFeTimeDiff >= 0) {
            //     timeslot = currentDate.add(serverFeTimeDiff , 'hours').format("hh:mm A")
            //     currentDate = currentDate.add(serverFeTimeDiff , 'hours').tz("UTC")
            // } else {
            //     timeslot = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').format("hh:mm A")
            //     currentDate = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').tz("UTC")
            // }
            // then get start of day
            // then add the fixed hours like 02:00 AM == 2 hours
            // then convert it to UTC and save in server

            // currentDate = currentDate.startOf('day')

            // console.log('frontend time start day', currentDate)
            // currentDate = currentDate.add(2, "hours")
            // console.log(' added', currentDate)
            // console.log(' added', moment(currentDate).tz(user.timeZone))

            // currentDate = currentDate.tz("UTC")
            // console.log('timeslot ',timeslot)

            // let final = moment
            //   .tz(handleDateConverter(date, time), moment.tz.guess())
            //   .tz("UTC")
            //   .toISOString();
            let final = moment(date).toISOString();

            _finalDateWithTimeSlots.push({
              // date :  handleDateConverter(date,time)?.toISOString(),
              date: final,
              timeslot: time,
            });

            // }
          });
        });
      } else {
        // For Month
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "month");
        }

        _dateRange?.forEach((date) => {
          // values?.timeSlots?.split(",").forEach((time) => {
          values?.timeSlots?.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      }
    } else if (values?.scheduleType === "daily") {
      while (_currentDate.isSameOrBefore(_endDate, "day")) {
        _dateRange.push(_currentDate.format(_format));
        _currentDate.add(values?.repeatEvery, "day");
      }

      _dateRange?.forEach((date) => {
        values?.timeSlots.forEach((time) => {
          _finalDateWithTimeSlots.push({
            date: moment(date).toISOString(),
            timeslot: time,
          });
        });
      });
    }
    return {
      scheduleDates: _finalDateWithTimeSlots,
      startDate: _startDate,
      endDate: _endDate,
    };
  };

  const onSave = async (values) => {
    if (
      (Number(values?.medicineRemaining) || 0) > Number(values?.totalMedicine)
    ) {
      return swal(
        "Error",
        "Current Medication Count cannot exceed Medication Total Quantity.",
        "error",
      );
    }

    if (
      Number(values?.medicationadministered) >
        Number(values?.medicineRemaining) &&
      !data
    ) {
      return swal(
        "Error",
        "Dosage Administered count cannot exceed Current Medication Count.",
        "error",
      );
    }

    let clientId = selectedClient ? selectedClient?.id : client?.id;

    if (data) {
      // Open version update modal for editing
      versionUpdateOpen(true);
      // const checkArrays = (arr1, arr2) => {
      //   if (
      //     !Array.isArray(arr1) ||
      //     !Array.isArray(arr2) ||
      //     arr1.length !== arr2.length
      //   ) {
      //     return true;
      //   }

      //   for (let i = 0; i < arr1.length; i++) {
      //     if (arr2.indexOf(arr1[i]) == -1) {
      //       return true;
      //     }
      //     // if (arr1[i] !== arr2[i]) {
      //     //   return true;
      //     // }
      //   }

      //   return false;
      // };
      // const _format = "YYYY-MM-DD";
      // const _medicationType = data?.medicationType !== values?.medicationType;
      // const _startDate =
      //   moment(data?.medicationDate).format(_format) !==
      //   moment(values?.medicationDate).format(_format);
      // const _endDate =
      //   data?.expirationDate &&
      //   data?.expirationDate != "null" &&
      //   moment(data?.expirationDate).format(_format) !==
      //     moment(values?.expirationDate).format(_format);
      // const _timeSlots = checkArrays(data?.timeSlots, values?.timeSlots);
      // const _repeatOn =
      //   data?.scheduleType === "custom"
      //     ? checkArrays(data?.repeatOn, values?.repeatOn)
      //     : false;

      // const _scheduleType =
      //   data?.scheduleType && values?.scheduleType
      //     ? data?.scheduleType !== values?.scheduleType
      //     : false;
      // const _repeatEvery =
      //   data?.scheduleType === "custom"
      //     ? Number(data?.repeatEvery) &&
      //       Number(data?.repeatEvery) != Number(values?.repeatEvery)
      //     : false;
      // const _repeatType =
      //   data?.scheduleType === "custom"
      //     ? data?.repeatType && data?.repeatType !== values?.repeatType
      //     : false;

      //     if (
      //       _medicationType ||
      //       _startDate ||
      //       _endDate ||
      //       _timeSlots ||
      //       _scheduleType ||
      //       _repeatEvery ||
      //       _repeatType ||
      //       _repeatOn
      //     ) {
      //   confirmOpen();
      // } else {
      //   handleEdit(false);
      // }
    } else {
      if (!values?.timeSlots?.length && values?.medicationType != "PRN")
        return showError("Select time slots for medicine.");

      const { scheduleDates } = setScheduleDates(values);

      const _formData = new FormData();
      files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
      // _formData.append("administering", values?.administering);
      _formData.append("dosage", values?.dosage);
      _formData.append("dosageForm", values?.dosageForm);
      _formData.append(
        "expirationDate",
        // values?.expirationDate ? values?.expirationDate?.toISOString() : null
        values?.expirationDate
          ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : null,
        // values?.expirationDate ? moment(values?.expirationDate)?.endOf("D") : null
      );
      _formData.append("frequency", values?.frequency);
      _formData.append("ingestionMode", values?.ingestionMode);
      _formData.append("isNarcotic", values?.isNarcotic);
      _formData.append("isPrescribed", values?.isPrescribed);
      _formData.append("rxNumber", values?.rxNumber || "");
      _formData.append(
        "medicationDate",
        values?.medicationDate ? values?.medicationDate?.toISOString() : null,
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D")?.toISOString() : null
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D") : null
      );

      // Start of Day on Frontend Date with 00:00:00 1 Aug 2024 Karachi Time.

      _formData.append("medicationInstruction", values?.medicationInstruction);
      _formData.append("medicationName", values?.medicationName);
      _formData.append(
        "medicationType",
        JSON.stringify([
          { status: values?.medicationType, date: moment().toISOString() },
        ]),
      );
      // _formData.append("medicationUse", values?.medicationUse);
      _formData.append(
        "medicationadministered",
        values?.medicationadministered,
      );
      _formData.append(
        "medicineRemaining",
        // Number(values?.medicineRemaining) || 0
        values?.medicineRemaining,
      );
      _formData.append("orderDate", values?.orderDate?.toISOString());
      // _formData.append("responsibleParty", values?.responsibleParty);
      _formData.append("timeSlots", values?.timeSlots);
      _formData.append("totalMedicine", values?.totalMedicine);
      _formData.append("unit", values?.unit);
      _formData.append("strengthAndForm", values?.strengthAndForm || "");
      if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
        _formData.append("refillsLeft", Number(values.refillsLeft));
      }
      _formData.append(
        "medicineProvided",
        Number(values?.medicineRemaining) || 0,
      );
      _formData.append("id", Date.now());
      // Always send all schedule fields so backend stores correct metadata in MAR doc
      _formData.append("scheduleType", values?.scheduleType || "daily");
      _formData.append(
        "repeatEvery",
        values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
      );
      _formData.append(
        "repeatType",
        values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
      );
      _formData.append(
        "repeatOn",
        values?.scheduleType === "custom"
          ? (values?.repeatOn || []).join(",")
          : "",
      );
      _formData.append(
        "medicationEndDate",
        values?.expirationDate
          ? // ? moment(values?.expirationDate)?.toISOString()
            moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : // ? moment(values?.expirationDate)?.endOf("D")
            moment().endOf("year").toISOString(),
      );
      // _formData.append(
      //   "medicationEndDate",
      //   values?.expirationDate
      //     ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
      //     : moment(values?.medicationDate)?.endOf("D")?.toISOString()
      // );

      _formData.append("scheduleDates", JSON.stringify(scheduleDates));

      _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
      // _formData.append("timezone", businessTimezone ? businessTimezone : moment.tz.guess());

      setLoading(true);
      await AddMedication(_formData, clientId, false, null, reset);
      if (selectedClient) {
        closeAskMedicalModal();
        setShowClientForm(false);
      }
      setLoading(false);
    }
  };

  const handleUpdateThisMedication = () => {
    // Close version update modal
    versionUpdateClose();
    const checkArrays = (arr1, arr2) => {
      if (
        !Array.isArray(arr1) ||
        !Array.isArray(arr2) ||
        arr1.length !== arr2.length
      ) {
        return true;
      }

      for (let i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) == -1) {
          return true;
        }
        // if (arr1[i] !== arr2[i]) {
        //   return true;
        // }
      }

      return false;
    };
    const values = form.values;
    const _format = "YYYY-MM-DD";
    const _medicationType = data?.medicationType !== values?.medicationType;
    const _startDate =
      moment(data?.medicationDate).format(_format) !==
      moment(values?.medicationDate).format(_format);
    const _endDate =
      data?.expirationDate &&
      data?.expirationDate != "null" &&
      moment(data?.expirationDate).format(_format) !==
        moment(values?.expirationDate).format(_format);
    const _timeSlots = checkArrays(data?.timeSlots, values?.timeSlots);
    const _repeatOn =
      data?.scheduleType === "custom"
        ? checkArrays(data?.repeatOn, values?.repeatOn)
        : false;

    const _scheduleType =
      data?.scheduleType && values?.scheduleType
        ? data?.scheduleType !== values?.scheduleType
        : false;
    const _repeatEvery =
      data?.scheduleType === "custom"
        ? Number(data?.repeatEvery) &&
          Number(data?.repeatEvery) != Number(values?.repeatEvery)
        : false;
    const _repeatType =
      data?.scheduleType === "custom"
        ? data?.repeatType && data?.repeatType !== values?.repeatType
        : false;

    if (
      _medicationType ||
      _startDate ||
      _endDate ||
      _timeSlots ||
      _scheduleType ||
      _repeatEvery ||
      _repeatType ||
      _repeatOn
    ) {
      confirmOpen();
    } else {
      handleEdit(false);
    }
  };

  const handleEdit = async (confirm) => {
    if (confirmModal) {
      confirmClose();
    }
    const values = form.values;

    let current = moment().startOf("day");
    // const { scheduleDates } = setScheduleDates({
    //   ...values,
    //   medicationDate: current,
    // });

    // const { scheduleDates } = setScheduleDates(values)

    const _formData = new FormData();
    // files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
    if (files?.length > 0) {
      _formData.append("file", files[0]?.uploadURL);
    } else if (data?.doctorNote) {
      // If files array is empty but data has a doctor note, preserve it
      _formData.append("file", data.doctorNote);
    }
    // _formData.append("administering", values?.administering);
    _formData.append("dosage", values?.dosage);
    _formData.append("dosageForm", values?.dosageForm);
    _formData.append(
      "expirationDate",
      values?.expirationDate ? values?.expirationDate?.toISOString() : null,
    );
    _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    _formData.append("frequency", values?.frequency);
    _formData.append("ingestionMode", values?.ingestionMode);
    _formData.append("isNarcotic", values?.isNarcotic);
    _formData.append("isPrescribed", values?.isPrescribed);
    _formData.append("rxNumber", values?.rxNumber || "");
    _formData.append(
      "medicationDate",
      values?.medicationDate ? values?.medicationDate?.toISOString() : null,
    );
    _formData.append("medicationInstruction", values?.medicationInstruction);
    _formData.append("medicationName", values?.medicationName);
    _formData.append(
      "medicationType",
      JSON.stringify(
        Array.isArray(data?.medicationType)
          ? [
              ...data.medicationType,
              { status: values?.medicationType, date: moment().toISOString() },
            ]
          : [{ status: values?.medicationType, date: moment().toISOString() }],
      ),
    );
    // _formData.append("medicationUse", values?.medicationUse);
    _formData.append("medicationadministered", values?.medicationadministered);
    // _formData.append("medicineRemaining", Number(data?.medicineRemaining) || 0);
    // _formData.append("medicineRemaining", data?.medicineRemaining);
    _formData.append("orderDate", values?.orderDate?.toISOString());
    // _formData.append("responsibleParty", values?.responsibleParty);
    _formData.append("timeSlots", values?.timeSlots);
    // Use isMedicationCountEnabled as source of truth for totalMedicine
    _formData.append(
      "totalMedicine",
      isMedicationCountEnabled?.toLowerCase() === "no"
        ? "unlimited"
        : values?.totalMedicine,
    );
    _formData.append("unit", values?.unit);
    if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
      _formData.append("refillsLeft", Number(values.refillsLeft));
    }
    _formData.append("strengthAndForm", values?.strengthAndForm || "");
    _formData.append("medicineProvided", Number(data?.medicineRemaining) || 0);
    _formData.append("id", data?.id);
    // Always send all schedule fields so backend can clear stale custom values when switching to daily
    _formData.append("scheduleType", values?.scheduleType || "daily");
    _formData.append(
      "repeatEvery",
      values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
    );
    _formData.append(
      "repeatType",
      values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
    );
    _formData.append(
      "repeatOn",
      values?.scheduleType === "custom"
        ? (values?.repeatOn || []).join(",")
        : "",
    );
    _formData.append("confirm", confirm);
    _formData.append(
      "medicationEndDate",
      values?.expirationDate
        ? moment(values?.expirationDate)?.toISOString()
        : moment().endOf("year").toISOString(),
      // : moment(values?.medicationDate)?.toISOString()
    );
    // _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    // _formData.append("scheduleDates", JSON.stringify(scheduleDates));

    // Always derive medicineRemaining and totalMedicine from the current toggle
    // state, not from the original DB value. This fixes limited→unlimited→limited
    // toggling where the old code sent data?.medicineRemaining (stale DB value).
    if (isMedicationCountEnabled?.toLowerCase() === "no") {
      _formData.append("medicineRemaining", "unlimited");
    } else {
      // Limited: send whatever the user currently has in the form fields.
      // values?.medicineRemaining is kept in sync by handleRadioChange.
      _formData.append("medicineRemaining", values?.medicineRemaining);
    }

    let newStartDate = moment(values?.medicationDate).format("MM-DD-YYYY");
    let oldStartDate = moment(data?.medicationDate).format("MM-DD-YYYY");
    // let oldScheduleType = data?.scheduleType;
    // _formData.append("old_schedule_type", oldScheduleType);
    // _formData.append("old_timeSlots", data?.timeSlots);

    let newEndDate = values?.expirationDate
      ? moment(values?.expirationDate)?.toISOString()
      : moment(values?.medicationDate)?.toISOString();
    // let newEndDate = moment(values?.expirationDate).format("MM-DD-YYYY");
    let oldEndDate = moment(data?.medicationEndDate).format("MM-DD-YYYY");

    if (moment(newStartDate) < moment(oldStartDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "week"){
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.expirationDate),
      //     // expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   let filteredSchedules = scheduleDates?.filter(_s => moment(_s?.date).isBefore(data?.medicationDate))

      //   _formData.append("new_start_schedules", JSON.stringify(filteredSchedules));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // } else {
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // }

      const { scheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: moment(data?.medicationDate).subtract(1, "days"),
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });

      _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    } else if (moment(newStartDate) > moment(oldStartDate)) {
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    }

    if (moment(newEndDate) < moment(oldEndDate)) {
      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    } else if (moment(newEndDate) > moment(oldEndDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "day"){
      if (values?.scheduleType === "custom") {
        const { scheduleDates } = setScheduleDates({
          // medicationDate: moment(data?.expirationDate).add(1, "days"),
          medicationDate: values?.medicationDate,
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });
        let filteredSchedules = scheduleDates?.filter((_s) =>
          moment(_s?.date).isAfter(data?.expirationDate),
        );

        _formData.append(
          "new_end_schedules",
          JSON.stringify(filteredSchedules),
        );
      } else {
        const { scheduleDates } = setScheduleDates({
          medicationDate: moment(data?.expirationDate).add(1, "days"),
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });

        _formData.append("new_end_schedules", JSON.stringify(scheduleDates));
      }

      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    }

    const scheduleChanged =
      values?.scheduleType !== data?.scheduleType ||
      JSON.stringify(values?.timeSlots) !== JSON.stringify(data?.timeSlots) ||
      JSON.stringify(values?.repeatOn) !== JSON.stringify(data?.repeatOn) ||
      values?.repeatType !== data?.repeatType ||
      Number(values?.repeatEvery) !== Number(data?.repeatEvery);

    if (scheduleChanged) {
      const { scheduleDates: newScheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: values?.expirationDate,
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });
      _formData.append("updateSchedule", true);
      _formData.append("scheduleDates", JSON.stringify(newScheduleDates));
    }
    setLoading(true);
    await EditMedication(_formData, client?.id, false, reset);
    if (versionUpdateModal) {
      versionUpdateClose();
    }
    setLoading(false);
  };

  const handleNewVersion = async (newStartDate, newExpirationDate) => {
    setLoading(true);
    const values = form.values;

    try {
      const obj = {
        clientId: client?.id,
        medicationId: data?.id,
        discontinuedOn: moment(newStartDate)
          .subtract(1, "days")
          .endOf("day")
          .toISOString(),
      };
      const res = await updateDiscontinue(obj, client?.id);

      if (res?.status !== 200) {
        throw new Error("Failed to discontinue medication");
      }

      const versionValues = {
        ...values,
        medicationDate: newStartDate ? new Date(newStartDate) : new Date(),
        expirationDate: newExpirationDate ? new Date(newExpirationDate) : null,
      };

      const { scheduleDates } = setScheduleDates(versionValues);

      const _formData = new FormData();
      files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
      // _formData.append("administering", values?.administering);
      _formData.append("dosage", values?.dosage);
      _formData.append("dosageForm", values?.dosageForm);
      _formData.append(
        "expirationDate",
        versionValues?.expirationDate
          ? moment(versionValues?.expirationDate)?.endOf("D")?.toISOString()
          : null,
      );
      _formData.append("frequency", values?.frequency);
      _formData.append("ingestionMode", values?.ingestionMode);
      _formData.append("isNarcotic", values?.isNarcotic);
      _formData.append("isPrescribed", values?.isPrescribed);
      _formData.append("rxNumber", values?.rxNumber || "");
      _formData.append(
        "medicationDate",
        versionValues?.medicationDate
          ? versionValues?.medicationDate?.toISOString()
          : null,
      );

      _formData.append("medicationInstruction", values?.medicationInstruction);
      _formData.append("medicationName", values?.medicationName);
      _formData.append(
        "medicationType",
        JSON.stringify([
          { status: values?.medicationType, date: moment().toISOString() },
        ]),
      );
      // _formData.append("medicationUse", values?.medicationUse);
      _formData.append(
        "medicationadministered",
        values?.medicationadministered,
      );
      _formData.append("medicineRemaining", values?.medicineRemaining);
      _formData.append("orderDate", values?.orderDate?.toISOString());
      // _formData.append("responsibleParty", values?.responsibleParty);
      _formData.append("timeSlots", values?.timeSlots);
      _formData.append("totalMedicine", values?.totalMedicine);
      _formData.append("unit", values?.unit);
      if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
        _formData.append("refillsLeft", Number(values.refillsLeft));
      }
      _formData.append("strengthAndForm", values?.strengthAndForm || "");
      _formData.append(
        "medicineProvided",
        Number(values?.medicineRemaining) || 0,
      );
      _formData.append("id", Date.now());
      // Always send all schedule fields so backend stores correct metadata in MAR doc
      _formData.append("scheduleType", values?.scheduleType || "daily");
      _formData.append(
        "repeatEvery",
        values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
      );
      _formData.append(
        "repeatType",
        values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
      );
      _formData.append(
        "repeatOn",
        values?.scheduleType === "custom"
          ? (values?.repeatOn || []).join(",")
          : "",
      );
      _formData.append(
        "medicationEndDate",
        versionValues?.expirationDate
          ? moment(versionValues?.expirationDate)?.endOf("D")?.toISOString()
          : moment().endOf("year").toISOString(),
      );
      // _formData.append(
      //   "medicationEndDate",
      //   values?.expirationDate
      //     ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
      //     : moment(values?.medicationDate)?.endOf("D")?.toISOString()
      // );

      _formData.append("scheduleDates", JSON.stringify(scheduleDates));

      _formData.append(
        "hasExpiryDate",
        versionValues?.expirationDate ? true : false,
      );
      _formData.append("previousMedId", data?.id);

      await AddMedication(_formData, client?.id, false, null, reset, false);

      versionUpdateClose();
      setLoading(false);
      swal(
        "Success",
        "New medication version created successfully.",
        "success",
      );
    } catch (error) {
      console.error(error);
      showError(error.message || "Operation failed");
      setLoading(false);
    }
  };

  const formatString = (str) => {
    const words = str?.split("");
    if (words?.length <= 15) {
      return str;
    }
    const startWords = words?.slice(0, 10)?.join("");
    const endWords = words?.slice(-10)?.join("");
    return `${startWords} ... ${endWords}`;
  };

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleDownloadFile = async (url) => {
    try {
      if (url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const filename = url?.split("/")?.pop();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } else {
        console.error("No url found");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const onChangeMedStartDate = (_sDate) => {
    if (data) {
      // form.values?.repeatType === "week"
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid start date");
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "week") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const repeatEvery = Number(form.values?.repeatEvery); // e.g., 1 or 2
          const repeatOn = form.values?.repeatOn || [];

          const newDayName = newDate.format("dddd"); // Day name of new start date

          // Step 2: Ensure the new start date is also in repeatOn
          if (!repeatOn.includes(newDayName)) {
            return alert(
              `Invalid start date. Please select a date that falls on: ${repeatOn.join(
                ", ",
              )}.`,
            );
          }

          // console.log("firstValidDay and newDate", moment(firstValidDay).format("MM-DD-YYYY"), moment(newDate).format("MM-DD-YYYY"))

          // Step 3: Ensure the new date is a multiple of repeatEvery weeks from first valid occurrence
          let weekDiff;
          if (newDate < original) {
            weekDiff = original.diff(newDate.startOf("week"), "weeks");
          } else {
            weekDiff = newDate.diff(original.startOf("week"), "weeks");
          }

          if (Math.abs(weekDiff) % repeatEvery !== 0) {
            return alert(
              `Invalid start date. Please select a date that repeats every ${repeatEvery} weeks on ${repeatOn.join(
                ", ",
              )}.`,
            );
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "month") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const originalDay = original.date(); // e.g., 10th of the month
          const newDay = newDate.date();
          const repeatMonths = Number(form.values?.repeatEvery); // e.g., 1 or 2

          if (repeatMonths === 1) {
            // User can only select the same day of the month (e.g., 10th)
            if (newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th of the month.`,
              );
            }
          } else if (repeatMonths > 1) {
            // Ensure the new date is every `repeatMonths` interval
            const monthDiff = newDate.diff(original, "months");
            if (monthDiff % repeatMonths !== 0 || newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th every ${repeatMonths} months.`,
              );
            }
          }

          form.setFieldValue("medicationDate", _sDate);
        }
      } else {
        form.setFieldValue("medicationDate", _sDate);
      }
    } else {
      form.setFieldValue("medicationDate", _sDate);
    }
  };

  const onChangeMedEndDate = (_sDate) => {
    if (data) {
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.expirationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid end date");
          } else {
            form.setFieldValue("expirationDate", _sDate);
          }
          // } else if(form.values?.repeatType === "month"){
        } else {
          form.setFieldValue("expirationDate", _sDate);
        }
      } else {
        form.setFieldValue("expirationDate", _sDate);
      }
    } else {
      form.setFieldValue("expirationDate", _sDate);
    }
  };

  // Compress images larger than 2 MB so the OCR API doesn't time out on mobile photos.
  const compressImage = (file) =>
    new Promise((resolve) => {
      const MAX_WIDTH = 1920;
      const QUALITY = 0.82;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        const canvas = document.createElement("canvas");
        let { width, height } = img;
        if (width > MAX_WIDTH) {
          height = Math.round((height * MAX_WIDTH) / width);
          width = MAX_WIDTH;
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => resolve(new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), { type: "image/jpeg" })),
          "image/jpeg",
          QUALITY,
        );
      };
      img.src = objectUrl;
    });

  // Shared OCR processing — called from both file-input and webcam capture.
  const processScanFile = async (file) => {
    setScanImage(URL.createObjectURL(file));
    setScanState("scanning");
    try {
      const extracted = await scanMedicationLabel(file);
      const confidenceMap = new Map();
      const updates = {};

      const fieldMap = {
        medicationName: "medicationName",
        dosage: "dosage",
        unit: "unit",
        frequency: "frequency",
        route: "ingestionMode",
        doseForm: "dosageForm",
        rxNumber: "rxNumber",
        quantity: "totalMedicine",
        instructions: "medicationInstruction",
      };

      Object.entries(fieldMap).forEach(([ocrKey, formKey]) => {
        const entry = extracted?.[ocrKey];
        if (entry?.value !== null && entry?.value !== undefined && entry?.confidence > 0) {
          updates[formKey] = entry.value;
          confidenceMap.set(formKey, entry.confidence);
        }
      });

      // Capitalize doseForm to match select options ("tablet" → "Tablet")
      if (updates.dosageForm) {
        const raw = String(updates.dosageForm);
        updates.dosageForm = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
      }

      // Map scheduleType → medicationType ("Scheduled" → "scheduled", "PRN" → "PRN")
      const scheduleEntry = extracted?.scheduleType;
      if (scheduleEntry?.value !== null && scheduleEntry?.value !== undefined && scheduleEntry?.confidence > 0) {
        const raw = String(scheduleEntry.value).toLowerCase();
        const medType = raw === "prn" ? "PRN" : raw;
        updates.medicationType = medType;
        confidenceMap.set("medicationType", scheduleEntry.confidence);
      }

      // Map narcoticStatus (boolean) → isNarcotic ("Yes" / "No")
      const narcoticEntry = extracted?.narcoticStatus;
      if (narcoticEntry?.value !== null && narcoticEntry?.value !== undefined && narcoticEntry?.confidence > 0) {
        updates.isNarcotic = narcoticEntry.value ? "Yes" : "No";
        confidenceMap.set("isNarcotic", narcoticEntry.confidence);
      }

      // Map isPrescribed (boolean) → isPrescribed ("Yes" / "No"); default "Yes" when OTC not detected
      const isPrescribedEntry = extracted?.isPrescribed;
      if (isPrescribedEntry != null) {
        updates.isPrescribed = isPrescribedEntry.value === false ? "No" : "Yes";
        confidenceMap.set("isPrescribed", isPrescribedEntry.confidence ?? 100);
      }

      // Map timeSlots (array) — normalize to zero-padded "08:00 AM" format
      const timeSlotsEntry = extracted?.timeSlots;
      if (Array.isArray(timeSlotsEntry?.value) && timeSlotsEntry.value.length > 0 && timeSlotsEntry.confidence > 0) {
        updates.timeSlots = timeSlotsEntry.value.map((t) => {
          const match = String(t).match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
          if (!match) return t;
          const hour = match[1].padStart(2, "0");
          return `${hour}:${match[2]} ${match[3].toUpperCase()}`;
        });
        confidenceMap.set("timeSlots", timeSlotsEntry.confidence);
      }

      // Map administrationCount → medicationadministered (stored as string)
      const adminCountEntry = extracted?.administrationCount;
      if (adminCountEntry?.value !== null && adminCountEntry?.value !== undefined && adminCountEntry?.confidence > 0) {
        updates.medicationadministered = String(adminCountEntry.value);
        confidenceMap.set("medicationadministered", adminCountEntry.confidence);
      }

      // Map refillsCount → refillsLeft (stored as string)
      const refillsEntry = extracted?.refillsCount;
      if (refillsEntry?.value !== null && refillsEntry?.value !== undefined && refillsEntry?.confidence > 0) {
        updates.refillsLeft = String(refillsEntry.value);
        confidenceMap.set("refillsLeft", refillsEntry.confidence);
      }

      if (Object.keys(updates).length > 0) {
        form.setValues((current) => ({ ...current, ...updates }));
        if (updates.medicationType) setType(updates.medicationType);
      }

      setScanState("done");
      setScannedFields(confidenceMap);
    } catch (err) {
      setScanState("idle");
      setScanImage(null);
      if (scanInputRef.current) scanInputRef.current.value = "";
      showError("OCR scan failed. Please fill fields manually.");
    }
  };

  const handleScanFileChange = async (e) => {
    let file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) file = await compressImage(file);
    await processScanFile(file);
  };

  // ── Webcam helpers ──────────────────────────────────────────────────────────
  // Attach the stream once the video element is in the DOM (cameraOpen → true).
  // iOS Safari needs both srcObject assignment AND an explicit play() after mount;
  // a setTimeout(0) fires before React commits the element, causing a black screen
  // on first open. useEffect runs after the commit, so the element is always ready.
  useEffect(() => {
    if (cameraOpen && videoRef.current && streamRef.current) {
      videoRef.current.srcObject = streamRef.current;
      videoRef.current.play().catch(() => {});
    }
  }, [cameraOpen]);

  const openCamera = async (facing = "environment") => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: facing } } });
      streamRef.current = stream;
      setFacingMode(facing);
      setCameraOpen(true); // useEffect above will assign srcObject + call play()
    } catch {
      showError("Camera access denied or not available. Please allow camera permissions and try again.");
    }
  };

  const switchCamera = async () => {
    const newFacing = facingMode === "environment" ? "user" : "environment";
    streamRef.current?.getTracks().forEach((t) => t.stop());
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: newFacing } } });
      streamRef.current = stream;
      setFacingMode(newFacing);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play().catch(() => {});
      }
    } catch {
      showError("Could not switch camera.");
    }
  };

  const closeCamera = () => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    setCameraOpen(false);
  };

  const captureFromCamera = async () => {
    const video = videoRef.current;
    if (!video) return;
    const width = video.videoWidth;
    const height = video.videoHeight;
    if (!width || !height) {
      showError("Camera is still loading. Please wait a moment and try again.");
      return;
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(video, 0, 0, width, height);
    canvas.toBlob(async (blob) => {
      if (!blob || blob.size < 5000) {
        showError("Failed to capture photo. Please try again.");
        return;
      }
      closeCamera();
      let file = new File([blob], "camera-capture.jpg", { type: "image/jpeg" });
      if (file.size > 2 * 1024 * 1024) file = await compressImage(file);
      await processScanFile(file);
    }, "image/jpeg", 0.92);
  };

  const scannedBadge = (formKey) => {
    const confidence = scannedFields.get(formKey);
    if (confidence === undefined) return null;
    const color = confidence >= 80 ? "#22c55e" : confidence >= 50 ? "#f59e0b" : "#ef4444";
    return (
      <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color, background: color + "1A", borderRadius: 4, padding: "1px 5px", verticalAlign: "middle" }}>
        {confidence}%
      </span>
    );
  };

  const resetScan = () => {
    setScanState("idle");
    setScannedFields(new Map());
    setScanImage(null);
    smsOcrDataRef.current = null;
    if (scanInputRef.current) scanInputRef.current.value = "";
    form.reset();
    resetSmsForm();
  };

  const savedContacts = useMemo(() => {
    const list = [];
    if (form2?.emergencyContactName && form2?.emergencyContactPhoneNumber)
      list.push({ name: form2.emergencyContactName, phone: form2.emergencyContactPhoneNumber, role: "Emergency Contact" });
    if (form2?.caseManagerName && form2?.caseManagerPhoneNumber)
      list.push({ name: form2.caseManagerName, phone: form2.caseManagerPhoneNumber, role: "Case Manager" });
    if (form2?.pcpName && form2?.pcpPhoneNumber)
      list.push({ name: form2.pcpName, phone: form2.pcpPhoneNumber, role: "Primary Care Provider" });
    (form2?.additionalProvider || []).forEach((p) => {
      if (p.providerName && p.providerPhone)
        list.push({ name: p.providerName, phone: p.providerPhone, role: p.providerType || "Provider" });
    });
    return list;
  }, [form2]);

  const isValidSmsPhone = (p) => (p?.replace(/\D/g, "")?.length || 0) >= 10;

  const smsFormatCountdown = (s) => {
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${String(r).padStart(2, "0")}`;
  };

  useEffect(() => {
    if (!smsSent || smsImageReceived) return;
    if (smsSecondsLeft <= 0) {
      setSmsSent(false);
      setSmsPhone("+1");
      return;
    }
    const t = setTimeout(() => setSmsSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [smsSent, smsSecondsLeft, smsImageReceived]);

  const handleSmsSend = async () => {
    if (!isValidSmsPhone(smsPhone)) return;
    const clientId = selectedClient ? selectedClient?.id : client?.id;
    setSmsSending(true);
    try {
      await requestSmsUpload({ clientId, phoneNumber: smsPhone, note: smsNote.trim() || undefined });
      setSmsSent(true);
      setSmsSecondsLeft(600);
    } catch {
      // error shown by service
    } finally {
      setSmsSending(false);
    }
  };

  const resetSmsForm = () => {
    setSmsPhone("+1");
    setSmsNote("");
    setSmsSent(false);
    setSmsSecondsLeft(0);
    setSmsImageReceived(false);
  };

  const scanStyles = {
    scanCard: {
      background: "#FFFFFF",
      border: "1px solid #E5E5E5",
      borderRadius: 12,
      padding: 16,
      marginBottom: 0,
    },
    scanHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      marginBottom: 12,
    },
    scanIconWrap: {
      width: 36,
      height: 36,
      borderRadius: 8,
      background: "#F9F5FF",
      border: "1px solid #E9D7FE",
      display: "grid",
      placeItems: "center",
      flexShrink: 0,
    },
    scanTitle: { margin: 0, fontSize: 14, fontWeight: 700, color: "#171717", fontFamily: "Inter" },
    scanSubtitle: { margin: "2px 0 0", fontSize: 12, color: "#525252", fontFamily: "Inter", lineHeight: 1.4 },
    scanResetBtn: {
      height: 28,
      padding: "0 10px",
      borderRadius: 6,
      border: "1px solid #D0D5DD",
      background: "#FFFFFF",
      color: "#1D2939",
      fontSize: 12,
      fontWeight: 600,
      fontFamily: "Inter",
      cursor: "pointer",
      boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
    },
    sectionCard: {
      background: "#FFFFFF",
      borderRadius: 12,
      border: "1px solid #E5E5E5",
      padding: 16,
      display: "flex",
      flexDirection: "column",
      gap: 12,
    },
    sectionTitle: {
      margin: "0 0 12px 0",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.6,
      color: "#737373",
      textTransform: "uppercase",
      fontFamily: "Inter",
    },
  };

  return (
    <Drawer
      // className={classes.addMedicationModal}
      opened={opened}
      onClose={() => {
        onclose();
        getAllPatients?.(currentPage, true, tabName);
        form?.reset();
        setRxStrengthOptions([]);
      }}
      closeOnClickOutside={false}
      withCloseButton={false}
      offset={isMobile ? 0 : 8}
      size={isMobile ? "100%" : "55%"}
      sx={{
        ".mantine-11shxvp": {
          background: "#F5F5F5",
          borderTopLeftRadius: isMobile ? 0 : 16,
          borderBottomLeftRadius: isMobile ? 0 : 16,
        },
        ".mantine-1q36a81": {
          padding: "0",
        },
      }}
      zIndex={1000}
      position="right"
      overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      shadow="md"
      styles={{
        root: { touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined },
        overlay: {
          touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined,
        },
        inner: { touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined },
        body: { touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined },
      }}
    >
      <form
        className={classes.modalBody}
        onSubmit={form?.onSubmit((values) => onSave(values))}
      >
        <div className={classes.modalTopBar}>
          <h3 className={classes.modalTitle}>
            {data
              ? isPreview
                ? "Preview Medication"
                : "Change Medication"
              : "Add new medication"}
          </h3>
          <button
            type="button"
            className={classes.modalCloseBtn}
            onClick={() => {
              onclose();
              getAllPatients?.(currentPage, true, tabName);
              form?.reset();
              setRxStrengthOptions([]);
            }}
          >
            ✕
          </button>
        </div>
        <div className={classes.formBox}>
          <div className={classes.wrapper}>
            <div className={classes.clientCard}>
              <img
                src={
                  selectedClient
                    ? decrypt(selectedClient?.imageurl) || defaultImage
                    : decrypt(client?.imageurl) || defaultImage
                }
                alt="client"
                className={classes.clientAvatar}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
              <div className={classes.clientInfo}>
                <p className={classes.clientName}>
                  {selectedClient
                    ? decrypt(selectedClient?.name)
                    : client?.name}
                </p>
                <p className={classes.clientId}>
                  {selectedClient
                    ? selectedClient?.id?.slice(0, 6)?.toUpperCase()
                    : client?.id?.slice(0, 6)?.toUpperCase()}
                </p>
              </div>
            </div>
            {/* ── Scan medication ── */}
            {!isPreview && (
              <div style={scanStyles.scanCard}>
                {/* header row */}
                <div style={scanStyles.scanHeader}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={scanStyles.scanIconWrap}>
                      {/* scan-line icon */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6941C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"/>
                        <path d="M3 6h2M19 6h2M3 18h2M19 18h2M7 3v3M17 3v3M7 18v3M17 18v3"/>
                      </svg>
                    </span>
                    <div>
                      <p style={scanStyles.scanTitle}>Scan medication</p>
                      <p style={scanStyles.scanSubtitle}>
                        Snap the Rx label or pill bottle. We'll read the name, strength,
                        route, frequency, and Rx number and pre-fill the form.
                      </p>
                    </div>
                  </div>

                  {/* Upload using a mobile phone — inline popover */}
                  <div style={{ position: "relative", flexShrink: 0 }}>
                    <button
                      type="button"
                      onClick={() => setSmsPopoverOpen(!smsPopoverOpen)}
                      style={{
                        background: "transparent", border: 0, padding: 0,
                        cursor: "pointer", fontFamily: "Inter", fontSize: 12, fontWeight: 600,
                        color: "#6941C6", textDecoration: "underline", whiteSpace: "nowrap",
                      }}
                    >
                      Upload using a mobile phone
                    </button>

                    {smsPopoverOpen && (
                      <>
                        <div
                          onClick={() => setSmsPopoverOpen(false)}
                          style={{ position: "fixed", inset: 0, zIndex: 1004, background: "transparent" }}
                        />
                        <div style={{
                          position: "absolute", top: "calc(100% + 8px)", right: 0,
                          zIndex: 1005, width: 320, background: "#FFFFFF",
                          border: "1px solid #E5E5E5", borderRadius: 10,
                          padding: 14, boxShadow: "0 12px 28px rgba(15,23,42,0.18)",
                          fontFamily: "Inter",
                        }}>
                          <button
                            type="button"
                            aria-label="Close"
                            onClick={() => setSmsPopoverOpen(false)}
                            style={{
                              position: "absolute", top: 8, right: 8,
                              width: 24, height: 24, borderRadius: 999,
                              border: 0, background: "transparent",
                              cursor: "pointer", color: "#737373",
                              display: "grid", placeItems: "center",
                              transition: "background .12s ease",
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = "#F2F4F7"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
                          >
                            <LuX size={14} color="#737373" />
                          </button>

                          <p style={{
                            margin: "0 24px 10px 0",
                            fontSize: 12, fontWeight: 500, color: "#262626", lineHeight: 1.4,
                          }}>
                            Send a secure link to a phone number to upload an image of the medication.
                          </p>

                          {smsSent ? (
                            <div style={{
                              display: "flex", flexDirection: "column", gap: 8,
                              padding: "10px 12px", borderRadius: 8,
                              background: "#F0FDF4", border: "1px solid #BBF7D0",
                            }}>
                              <div style={{
                                display: "flex", alignItems: "center", gap: 8,
                                color: "#15803D", fontSize: 12, fontWeight: 700,
                              }}>
                                <LuCheck size={14} color="#15803D" />
                                SMS sent to {smsPhone}
                              </div>
                              <p style={{ margin: 0, fontSize: 12, color: "#166534", lineHeight: 1.4 }}>
                                Link expires in{" "}
                                <strong style={{ fontVariantNumeric: "tabular-nums" }}>
                                  {smsFormatCountdown(smsSecondsLeft)}
                                </strong>
                                . You'll be notified when the image has been uploaded.
                              </p>
                              <button
                                type="button"
                                onClick={resetSmsForm}
                                style={{
                                  alignSelf: "flex-start",
                                  background: "transparent", border: 0, padding: 0,
                                  fontFamily: "Inter", fontSize: 12, fontWeight: 600,
                                  color: "#6941C6", textDecoration: "underline", cursor: "pointer",
                                }}
                              >
                                Send another link
                              </button>
                            </div>
                          ) : (
                            <Group spacing={6} noWrap align="flex-end">
                              <TextInput
                                type="tel"
                                placeholder="(555) 555-0123"
                                value={smsPhone}
                                onChange={(e) => setSmsPhone(e.target.value)}
                                size="sm"
                                radius="md"
                                sx={{ flex: 1 }}
                              />
                              <Button
                                color="violet"
                                size="sm"
                                radius="md"
                                loading={smsSending}
                                disabled={!isValidSmsPhone(smsPhone)}
                                onClick={handleSmsSend}
                                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                              >
                                Send SMS
                              </Button>
                            </Group>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* idle — dropzone */}
                {!scanImage && (
                  <label
                    style={{
                      display: "flex", flexDirection: "column", alignItems: "center",
                      justifyContent: "center", gap: 8, padding: "24px 16px",
                      border: "1px dashed #D0D5DD", borderRadius: 10,
                      background: "#FAFAFA", cursor: "pointer", textAlign: "center",
                      transition: "background .12s ease, border-color .12s ease",
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "#F5F3FF"; e.currentTarget.style.borderColor = "#B692F6"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "#FAFAFA"; e.currentTarget.style.borderColor = "#D0D5DD"; }}
                  >
                    {/* Upload image — hidden input, no capture so gallery/file-picker opens */}
                    <input
                      ref={scanInputRef}
                      type="file"
                      accept="image/*,.heic,.heif"
                      style={{ display: "none" }}
                      onChange={handleScanFileChange}
                    />
                    {/* iOS native camera — used instead of getUserMedia on iPhone/iPad */}
                    <input
                      ref={cameraInputRef}
                      type="file"
                      accept="image/*"
                      capture="environment"
                      style={{ display: "none" }}
                      onChange={handleScanFileChange}
                    />
                    <span style={{
                      width: 44, height: 44, borderRadius: "50%",
                      background: "#FFFFFF", border: "1px solid #E5E5E5",
                      display: "grid", placeItems: "center",
                      boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                    }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6941C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                        <circle cx="12" cy="13" r="4"/>
                      </svg>
                    </span>
                    <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#171717", fontFamily: "Inter" }}>
                      Tap to take a photo or upload an image
                    </p>
                    <p style={{ margin: 0, fontSize: 11, color: "#737373", fontFamily: "Inter" }}>
                      PNG, JPG, or HEIC · max 10MB
                    </p>
                    <div style={{ display: "inline-flex", gap: 8, marginTop: 4 }}>
                      <button
                        type="button"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); isIOS ? cameraInputRef.current?.click() : openCamera(); }}
                        style={{
                          display: "inline-flex", alignItems: "center", gap: 6,
                          height: 32, padding: "0 12px", borderRadius: 8,
                          border: "1px solid #6941C6", background: "#6941C6", color: "#FFFFFF",
                          fontSize: 12, fontWeight: 600, fontFamily: "Inter", cursor: "pointer",
                          boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                        }}
                      >
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                          <circle cx="12" cy="13" r="4"/>
                        </svg>
                        Take photo
                      </button>
                      <span style={{
                        display: "inline-flex", alignItems: "center", gap: 6,
                        height: 32, padding: "0 12px", borderRadius: 8,
                        border: "1px solid #D0D5DD", background: "#FFFFFF", color: "#1D2939",
                        fontSize: 12, fontWeight: 600, fontFamily: "Inter",
                        boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                      }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
                          <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                        </svg>
                        Upload image
                      </span>
                    </div>
                  </label>
                )}

                {/* scanning / done — thumbnail + status */}
                {scanImage && (
                  <div style={{
                    display: "flex", gap: 12, padding: 10, borderRadius: 10,
                    border: "1px solid #E5E5E5", background: "#FAFAFA",
                  }}>
                    <div style={{
                      width: 96, height: 96, borderRadius: 8, overflow: "hidden",
                      border: "1px solid #E5E5E5", background: "#FFFFFF", flexShrink: 0,
                      position: "relative",
                    }}>
                      <img src={scanImage} alt="Scanned medication"
                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                      {scanState === "scanning" && (
                        <div style={{
                          position: "absolute", inset: 0,
                          background: "rgba(105,65,198,0.18)",
                          display: "grid", placeItems: "center",
                        }}>
                          <Loader color="violet" size="xs" />
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", justifyContent: "center", gap: 4 }}>
                      {scanState === "scanning" && (
                        <>
                          <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#171717", fontFamily: "Inter" }}>
                            Scanning label…
                          </p>
                          <p style={{ margin: 0, fontSize: 11, color: "#525252", fontFamily: "Inter" }}>
                            Reading medication name, strength, and Rx number.
                          </p>
                        </>
                      )}
                      {scanState === "done" && (
                        <>
                          <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#15803D", fontFamily: "Inter", display: "inline-flex", alignItems: "center", gap: 6 }}>
                            ✓ Scan complete · {scannedFields.size} fields pre-filled
                          </p>
                          <p style={{ margin: 0, fontSize: 11, color: "#525252", fontFamily: "Inter", lineHeight: 1.4 }}>
                            Review the highlighted fields below and fill the remaining details before saving.
                          </p>
                        </>
                      )}
                      <div style={{ marginTop: 4, display: "flex", gap: 8 }}>
                        <button type="button" onClick={() => scanInputRef.current?.click()} style={scanStyles.scanResetBtn}>
                          Replace image
                        </button>
                        <button type="button" onClick={resetScan} style={{
                          height: 28, padding: "0 10px", borderRadius: 6,
                          border: 0, background: "transparent", color: "#B42318",
                          fontSize: 12, fontWeight: 600, fontFamily: "Inter", cursor: "pointer",
                        }}>
                          Remove
                        </button>
                      </div>
                      <input
                        ref={scanInputRef}
                        type="file"
                        accept="image/*"
                        capture="environment"
                        style={{ display: "none" }}
                        onChange={handleScanFileChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ── Section: Basics ── */}
            <div style={scanStyles.sectionCard}>
              <p style={scanStyles.sectionTitle}>Basics</p>
              <div className={classes.topFieldsBox}>
                {/* Is this a prescription medication? */}
                <div className="isPrescribed">
                  <Radio.Group
                    name="isPrescribed"
                    label={<span>Is this a prescription medication?{scannedBadge("isPrescribed")}</span>}
                    {...form.getInputProps("isPrescribed")}
                    required
                    withAsterisk
                    className={classes.radioGroupWrapper}
                  >
                    <Group className={classes.radioGroup}>
                      <Radio disabled={isPreview} value="Yes" label="Yes" />
                      <Radio disabled={isPreview} value="No" label="No" />
                    </Group>
                  </Radio.Group>
                </div>
                <div className="isNarcotic">
                  <Radio.Group
                    name="isNarcotic"
                    label={<span>Is this a narcotic?{scannedBadge("isNarcotic")}</span>}
                    {...form.getInputProps("isNarcotic")}
                    required
                    withAsterisk
                    disabled={isPreview}
                    className={classes.radioGroupWrapper}
                  >
                    <Group className={classes.radioGroup}>
                      <Radio disabled={isPreview} value="Yes" label="Yes" />
                      <Radio disabled={isPreview} value="No" label="No" />
                    </Group>
                  </Radio.Group>
                  {/* <NarcoticBox /> */}
                </div>
              </div>

              {/* medication name — RxTerms autocomplete, full width */}
              <div ref={rxDropdownRef} style={{ position: "relative" }}>
                <CustomTextInput
                  id="medication-name"
                  label={<span>Medication Name{scannedBadge("medicationName")}</span>}
                  placeholder={"Enter Medication Name"}
                  value={form.values.medicationName}
                  onChange={(e) => handleRxInputChange(e.target.value)}
                  error={form.errors.medicationName}
                  withAsterisk
                  disabled={isPreview}
                  autoComplete="off"
                  rightSection={
                    rxLoading ? (
                      <Loader color="yellow" size="xs" />
                    ) : form.values.medicationName && !isPreview ? (
                      <IoIosCloseCircle
                        style={{ cursor: "pointer", color: "#aaa", fontSize: 18 }}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          form.setFieldValue("medicationName", "");
                          form.setFieldValue("strengthAndForm", "");
                          setRxStrengthOptions([]);
                          setRxShowDropdown(false);
                          setRxSuggestions([]);
                        }}
                      />
                    ) : null
                  }
                />
                {rxShowDropdown && !isPreview && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #dee2e6",
                      borderRadius: 8,
                      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                      zIndex: 9999,
                      maxHeight: 260,
                      overflowY: "auto",
                    }}
                  >
                    {rxSuggestions.map((drug, idx) => (
                      <div
                        key={idx}
                        onMouseDown={() => handleRxSelect(drug)}
                        style={{
                          padding: "10px 14px",
                          cursor: "pointer",
                          borderBottom: idx < rxSuggestions.length - 1 ? "1px solid #f1f3f5" : "none",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fa")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                      >
                        <Text size="sm" weight={500}>{drug.displayName}</Text>
                        {drug.strengthsAndForms.length > 0 && (
                          <Text size="xs" color="dimmed">
                            {drug.strengthsAndForms.slice(0, 3).join(" · ")}
                            {drug.strengthsAndForms.length > 3 ? ` +${drug.strengthsAndForms.length - 3} more` : ""}
                          </Text>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Dosage information box */}
              <div style={{
                padding: 12, borderRadius: 10,
                background: "#FAFAFA", border: "1px solid #E5E5E5",
                display: "flex", flexDirection: "column", gap: 10,
              }}>
                <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#171717", fontFamily: "Inter" }}>
                  Dosage information <span style={{ color: "#B42318", fontWeight: 600 }}>*</span>
                </p>

                {rxStrengthOptions.length === 0 ? (
                  <div style={{ display: "flex", gap: 12 }}>
                    {/* Amount stepper */}
                    <div style={{ flex: 1 }}>
                      <p style={{ margin: "0 0 6px", fontSize: 13, fontWeight: 500, color: "#344054", fontFamily: "Inter" }}>Amount{scannedBadge("dosage")}</p>
                      <div style={{
                        display: "flex", alignItems: "center",
                        border: `1px solid ${form.errors.dosage ? "#fa5252" : "#D0D5DD"}`,
                        borderRadius: 8, background: "#FFFFFF",
                        paddingInline: 13,
                        boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                        height: 44,
                        opacity: isPreview ? 0.6 : 1,
                      }}>
                        <button type="button" disabled={isPreview}
                          onClick={() => { const v = parseFloat(form.values.dosage) || 0; form.setFieldValue("dosage", String(Math.max(0, v - 1))); }}
                          style={{ border: 0, background: "transparent", cursor: isPreview ? "not-allowed" : "pointer", padding: "0 4px", fontSize: 18, color: "#171717", lineHeight: 1 }}
                          aria-label="Decrease amount">−</button>
                        <input
                          type="number" min={0}
                          value={form.values.dosage}
                          onChange={(e) => form.setFieldValue("dosage", e.target.value)}
                          disabled={isPreview}
                          placeholder="0"
                          className={classes.noSpinner}
                          style={{
                            flex: 1, height: "100%", border: 0, outline: 0,
                            textAlign: "center", fontSize: 15, color: "#262626",
                            background: "transparent", fontFamily: "Inter",
                          }}
                        />
                        <button type="button" disabled={isPreview}
                          onClick={() => { const v = parseFloat(form.values.dosage) || 0; form.setFieldValue("dosage", String(v + 1)); }}
                          style={{ border: 0, background: "transparent", cursor: isPreview ? "not-allowed" : "pointer", padding: "0 4px", fontSize: 16, color: "#171717", lineHeight: 1 }}
                          aria-label="Increase amount">+</button>
                      </div>
                      {form.errors.dosage && (
                        <p style={{ margin: "4px 0 0", fontSize: 12, color: "#fa5252", fontFamily: "Inter" }}>{form.errors.dosage}</p>
                      )}
                    </div>
                    {/* Unit */}
                    <div style={{ flex: 1 }}>
                      <p style={{ margin: "0 0 6px", fontSize: 13, fontWeight: 500, color: "#344054", fontFamily: "Inter" }}>Unit{scannedBadge("unit")}</p>
                      <Select
                        id="medication-unit"
                        data={[
                          { value: "mg", label: "mg" },
                          { value: "mg/ml", label: "mg/ml" },
                          { value: "cc", label: "cc" },
                          { value: "iu", label: "iu" },
                          { value: "ml", label: "ml" },
                          { value: "puffs", label: "puffs" },
                          { value: "mcg", label: "mcg" },
                          { value: "g", label: "g" },
                          { value: "oz", label: "oz" },
                          { value: "gtts", label: "gtts" },
                          { value: "spray", label: "spray" },
                          { value: "drops", label: "drops" },
                          { value: "unit", label: "unit" },
                          { value: "tablet", label: "tablet" },
                        ]}
                        styles={{
                          input: { height: 44, borderColor: "#D0D5DD", borderRadius: 8, fontSize: 14, fontFamily: "Inter", boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)" },
                        }}
                        placeholder="Select unit…"
                        {...form.getInputProps("unit")}
                        rightSection={<IconChevronDown size={14} />}
                        disabled={isPreview}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p style={{ margin: "0 0 6px", fontSize: 13, fontWeight: 500, color: "#344054", fontFamily: "Inter" }}>Strength &amp; Form</p>
                    <Select
                      id="strength-and-form"
                      data={rxStrengthOptions}
                      styles={{
                        input: { height: 44, borderColor: "#D0D5DD", borderRadius: 8, fontSize: 14, fontFamily: "Inter", boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)" },
                      }}
                      placeholder="Select strength & form…"
                      {...form.getInputProps("strengthAndForm")}
                      rightSection={<IconChevronDown size={14} />}
                      disabled={isPreview}
                      clearable
                    />
                  </div>
                )}

                {/* Frequency — full width row below */}
                <div>
                  <p style={{ margin: "0 0 6px", fontSize: 13, fontWeight: 500, color: "#344054", fontFamily: "Inter" }}>
                    Frequency{scannedBadge("frequency")} <span style={{ color: "#B42318", fontWeight: 600 }}>*</span>
                  </p>
                  <Select
                    id="frequency"
                    styles={{
                      input: { height: 44, borderColor: "#D0D5DD", borderRadius: 8, fontSize: 14, fontFamily: "Inter", boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)" },
                    }}
                    data={[...new Set(frequencyData)]}
                    placeholder="Select frequency…"
                    {...form.getInputProps("frequency")}
                    rightSection={<IconChevronDown size={14} />}
                    disabled={isPreview}
                  />
                </div>
              </div>
              {/* medication route */}
              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomSelectBox
                  id="medication-route"
                  label={<span>Medication Route{scannedBadge("ingestionMode")}</span>}
                  placeholder={"Select medication route"}
                  data={[
                    { value: "Buccal", label: "Buccal" },
                    { value: "Orally", label: "Orally" },
                    { value: "Intramuscular", label: "Intramuscular" },
                    { value: "Subcutaneous", label: "Subcutaneous" },
                    { value: "Cutaneous", label: "Cutaneous" },
                    { value: "Irrigation", label: "Irrigation" },
                    { value: "Laryngeal", label: "Laryngeal" },
                    { value: "Nasal", label: "Nasal" },
                    { value: "Not Applicable", label: "Not Applicable" },
                    { value: "Parenteral", label: "Parenteral" },
                    { value: "Rectal", label: "Rectal" },
                    { value: "Vaginal", label: "Vaginal" },
                    { value: "Sublingual", label: "Sublingual" },
                    { value: "Suppository", label: "Suppository" },
                    { value: "Injection", label: "Injection" },
                    { value: "Inhalation", label: "Inhalation" },
                    { value: "Topical", label: "Topical" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("ingestionMode")}
                  withAsterisk
                  disabled={isPreview}
                />
                <CustomSelectBox
                  id="dose-form"
                  label={<span>Dose Form{scannedBadge("dosageForm")}</span>}
                  placeholder={"Select dose form"}
                  data={[
                    "Tablet",
                    "Capsule",
                    "Syrup",
                    "Pill",
                    "Liquid",
                    "Cream",
                    "Oil",
                    "Ointment",
                    "Lotion",
                    "Gel",
                    "Gas",
                    "Solution",
                    "Inhalant",
                    "Injection",
                    "Insert",
                    "Suppository",
                    "Jelly",
                    "Lozenge",
                    "Paste",
                    "Patch",
                    "Rinse",
                    "Shampoo",
                    "Drops",
                    "Spray",
                    "Powder",
                  ]}
                  {...form.getInputProps("dosageForm")}
                  disabled={isPreview}
                />
              </div>

              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomTextInput
                  id="rx-number"
                  label={<span>Rx Number{scannedBadge("rxNumber")}</span>}
                  placeholder="Enter Rx number"
                  {...form.getInputProps("rxNumber")}
                  disabled={isPreview}
                />
                <DateInput
                  id="expriration-date"
                  minDate={new Date()}
                  placeholder={"Pick a date"}
                  label="Expiration Date"
                  disabled={isPreview}
                  {...form.getInputProps("expirationDate")}
                  onChange={onChangeMedEndDate}
                  clearable
                  className={classes.inputStyle}
                  icon={<FiCalendar />}
                />
              </div>
            </div>

            {/* ── Section: Schedule ── */}
            <div style={scanStyles.sectionCard}>
              <p style={scanStyles.sectionTitle}>Schedule</p>
              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomSelectBox
                  id="medication-type"
                  label={<span>Medication Type{scannedBadge("medicationType")}</span>}
                  {...form.getInputProps("medicationType")}
                  onChange={(value) => {
                    form.setFieldValue("medicationType", value);
                    setType(value);
                  }}
                  placeholder={"Select Medication Type"}
                  withAsterisk
                  data={[
                    { value: "PRN", label: "PRN" },
                    { value: "scheduled", label: "SCHEDULED" },
                  ]}
                  disabled={isPreview}
                />
                {type !== "PRN" && (
                  <Select
                    data={[
                      { value: "daily", label: "Daily" },
                      { value: "custom", label: "Custom" },
                    ]}
                    label="Schedule Type"
                    placeholder="Select Schedule Type"
                    rightSection={<IconChevronDown />}
                    disabled={isPreview}
                    {...form.getInputProps("scheduleType")}
                    onChange={(value) => {
                      form.setFieldValue("scheduleType", value);
                      if (value === "daily") {
                        form.setFieldValue("repeatEvery", 1);
                        form.setFieldValue("repeatType", "day");
                      }
                    }}
                    className={classes.inputStyle}
                  />
                )}
                {type === "PRN" && (
                  <DateInput
                    id="medication-start-date"
                    placeholder={"Pick a date"}
                    label="Medication Start Date"
                    {...form.getInputProps("medicationDate")}
                    onChange={onChangeMedStartDate}
                    withAsterisk
                    disabled={isPreview}
                    className={classes.inputStyle}
                    icon={<FiCalendar />}
                  />
                )}
              </div>
              {type !== "PRN" && (
                <ScheduleMenu
                  form={form}
                  isPreview={isPreview}
                  data={data}
                  scannedBadge={scannedBadge}
                  showDetails={true}
                />
              )}
            </div>

            {/* ── Section: Inventory ── */}
            <div style={scanStyles.sectionCard}>
              <p style={scanStyles.sectionTitle}>Inventory</p>
              <Box mb={10}>
                <Radio.Group
                  label="Use Medication Count?"
                  onChange={handleRadioChange}
                  value={isMedicationCountEnabled}
                  disabled={isPreview}
                  className={classes.radioGroupWrapper}
                >
                  <Group className={classes.radioGroup}>
                    <Radio disabled={isPreview} value="yes" label="Yes" />
                    <Radio disabled={isPreview} value="no" label="No" />
                  </Group>
                </Radio.Group>
              </Box>

              {/* Total quantity + Remaining side by side */}
              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CountField
                  id="medication-quantity"
                  label="Total Quantity"
                  withAsterisk={
                    isMedicationCountEnabled?.toLowerCase() !== "no"
                  }
                  value={form.values.totalMedicine}
                  error={form.errors.totalMedicine}
                  disabled={
                    isPreview ||
                    isMedicationCountEnabled?.toLowerCase() === "no"
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 1) {
                        value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                      }
                    }
                    form.setFieldValue("totalMedicine", value);
                  }}
                  onDecrement={() => {
                    const v = parseFloat(form.values.totalMedicine) || 0;
                    form.setFieldValue(
                      "totalMedicine",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v = parseFloat(form.values.totalMedicine) || 0;
                    form.setFieldValue("totalMedicine", String(v + 1));
                  }}
                />
                <CountField
                  id="current-medication-count"
                  labelNode={
                    <Tooltip
                      label="Update Current Count from Refill Medication"
                      placement="top"
                      offset={15}
                      withArrow
                      arrowSize={8}
                      disabled={
                        isPreview ||
                        !data ||
                        (data?.medicineRemaining === "unlimited" &&
                          data?.totalMedicine === "unlimited")
                      }
                    >
                      <span>Remaining</span>
                    </Tooltip>
                  }
                  value={form.values.medicineRemaining}
                  error={form.errors.medicineRemaining}
                  disabled={
                    isPreview ||
                    isMedicationCountEnabled?.toLowerCase() === "no" ||
                    (isMedicationCountEnabled?.toLowerCase() === "yes" &&
                    data?.medicineRemaining === undefined
                      ? data?.medicineRemaining == "unlimited"
                      : data?.medicineRemaining !== "unlimited")
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 1) {
                        value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                      }
                    }
                    form.setFieldValue("medicineRemaining", value);
                  }}
                  onDecrement={() => {
                    const v = parseFloat(form.values.medicineRemaining) || 0;
                    form.setFieldValue(
                      "medicineRemaining",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v = parseFloat(form.values.medicineRemaining) || 0;
                    form.setFieldValue("medicineRemaining", String(v + 1));
                  }}
                />
              </div>

              {/* Administration count on its own row */}
              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CountField
                  id="administration-count"
                  label={<span>Administration Count{scannedBadge("medicationadministered")}</span>}
                  value={form.values.medicationadministered}
                  error={form.errors.medicationadministered}
                  disabled={isPreview}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 2) {
                        value = `${integerPart}.${decimalPart?.slice(0, 2)}`;
                      }
                    }
                    form.setFieldValue("medicationadministered", value);
                  }}
                  onDecrement={() => {
                    const v =
                      parseFloat(form.values.medicationadministered) || 0;
                    form.setFieldValue(
                      "medicationadministered",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v =
                      parseFloat(form.values.medicationadministered) || 0;
                    form.setFieldValue("medicationadministered", String(v + 1));
                  }}
                />
                <CountField
                  id="refills-left"
                  label={<span>Refills Count{scannedBadge("refillsLeft")}</span>}
                  value={form.values.refillsLeft}
                  error={form.errors.refillsLeft}
                  disabled={isPreview}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    form.setFieldValue("refillsLeft", value);
                  }}
                  onDecrement={() => {
                    const v = parseInt(form.values.refillsLeft, 10);
                    if (!isNaN(v) && v > 0)
                      form.setFieldValue("refillsLeft", String(v - 1));
                  }}
                  onIncrement={() => {
                    const v = parseInt(form.values.refillsLeft, 10) || 0;
                    form.setFieldValue("refillsLeft", String(v + 1));
                  }}
                />
              </div>
            </div>

            {/* ── Section: Clinical Detail ── */}
            <div style={scanStyles.sectionCard}>
              <p style={scanStyles.sectionTitle}>Clinical Detail</p>
              {/* use of medication */}
              {/* <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomTextArea
                  id="use-of-medication"
                  size="sm"
                  label={"Use of Medication"}
                  placeholder={"Enter medication use"}
                  minRows={3}
                  {...form.getInputProps("medicationUse")}
                  disabled={isPreview}
                />
              </div> */}
              {/* medication instruction */}
              <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomTextArea
                  id="medication-instruction"
                  size="sm"
                  label={<span>Medication Instruction{scannedBadge("medicationInstruction")}</span>}
                  placeholder={"Enter medication Instruction"}
                  minRows={3}
                  {...form.getInputProps("medicationInstruction")}
                  disabled={isPreview}
                />
              </div>

              {/* <div style={{ display: "flex", gap: 12, width: "100%" }}>
                <CustomSelectBox
                  id="responsible-for-purchasing"
                  label={"Responsible for purchasing"}
                  placeholder={"Select purchasing party"}
                  data={[
                    { value: "Family", label: "Family" },
                    { value: "Care Facility", label: "Care Facility" },
                    { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("responsibleParty")}
                  disabled={isPreview}
                />
                <CustomSelectBox
                  id="responsible-for-administering"
                  label={"Responsible for administering"}
                  placeholder={"Select administering party"}
                  data={[
                    { value: "Family", label: "Family" },
                    { value: "Care Facility", label: "Care Facility" },
                    { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("administering")}
                  disabled={isPreview}
                />
              </div> */}
            </div>

            {/* ── Section: Doctor's Note ── */}
            <div style={scanStyles.sectionCard}>
              <p style={scanStyles.sectionTitle}>Doctor's Note</p>

              {/* dropzone — idle: upload prompt; file picked: file row */}
              {files?.length === 0 ? (
                !isPreview && (
                  <Dropzone
                    onDrop={async (newFiles) => {
                      if (!newFiles?.[0]) return;
                      const file = newFiles[0];
                      try {
                        const result = await uploadFileToS3Api({ file });
                        const sizeKB = file.size / 1024;
                        const sizeLabel =
                          sizeKB >= 1024
                            ? (sizeKB / 1024).toFixed(1) + " MB"
                            : sizeKB.toFixed(0) + " KB";
                        setFiles([{ ...result, name: file.name, sizeLabel }]);
                      } catch (error) {
                        showError?.(error?.message || "Upload failed");
                      }
                    }}
                    multiple={false}
                    onReject={(f) => console.log("rejected files", f)}
                    disabled={isPreview}
                    styles={{
                      root: {
                        border: "1px dashed #D0D5DD",
                        borderRadius: 10,
                        background: "#FAFAFA",
                        padding: "20px 16px",
                        cursor: "pointer",
                        "&:hover": { background: "#F5F3FF", borderColor: "#B692F6" },
                      },
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, textAlign: "center", pointerEvents: "none" }}>
                      <span style={{
                        width: 36, height: 36, borderRadius: "50%",
                        background: "#FFFFFF", border: "1px solid #E5E5E5",
                        display: "grid", placeItems: "center",
                        boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                      }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6941C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                          <polyline points="14 2 14 8 20 8"/>
                          <line x1="16" y1="13" x2="8" y2="13"/>
                          <line x1="16" y1="17" x2="8" y2="17"/>
                          <polyline points="10 9 9 9 8 9"/>
                        </svg>
                      </span>
                      <p style={{ margin: 0, fontSize: 13, fontFamily: "Inter", color: "#171717" }}>
                        <span style={{ fontWeight: 600, color: "#6941C6" }}>Click to upload</span>{" "}or drag and drop
                      </p>
                      <p style={{ margin: 0, fontSize: 11, color: "#737373", fontFamily: "Inter" }}>
                        PDF or image · max 2 MB
                      </p>
                    </div>
                  </Dropzone>
                )
              ) : (
                <div style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  gap: 10, padding: "10px 12px",
                  border: "1px solid #E5E5E5", borderRadius: 8, background: "#FAFAFA",
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                    <IconFile size={22} color="#888" strokeWidth={1.5} style={{ flexShrink: 0 }} />
                    <div style={{ minWidth: 0 }}>
                      <p style={{
                        margin: 0, fontSize: 13, fontWeight: 600, color: "#171717",
                        fontFamily: "Inter", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                      }}>
                        {files[0]?.name || formatString(files[0]?.path)}
                      </p>
                      {files[0]?.sizeLabel && (
                        <p style={{ margin: 0, fontSize: 11, color: "#737373", fontFamily: "Inter" }}>
                          Size: {files[0]?.sizeLabel}
                        </p>
                      )}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                    {files[0]?.uploadURL && (
                      <button
                        type="button"
                        onClick={() => window.open(files[0]?.uploadURL, "_blank")}
                        style={{
                          width: 28, height: 28, borderRadius: "50%", border: 0,
                          background: "transparent", color: "#888", cursor: "pointer",
                          display: "grid", placeItems: "center",
                        }}
                      >
                        <EyeIconSvg size={16} color="#555" strokeWidth={1.5} />
                      </button>
                    )}
                    {!isPreview && (
                      <button
                        type="button"
                        onClick={() => { setFiles([]); form.setFieldValue("files", []); }}
                        style={{
                          width: 28, height: 28, borderRadius: "50%", border: 0,
                          background: "transparent", color: "#888", cursor: "pointer",
                          display: "grid", placeItems: "center",
                        }}
                      >
                        <IoIosCloseCircle color="#888" size={18} />
                      </button>
                    )}
                  </div>
                </div>
              )}

              {/* order date */}
              <div style={{ marginTop: 12 }}>
                <DatePickerInput
                  id="order-date"
                  label="Order Date"
                  placeholder="Pick a date"
                  className={classes.inputStyle}
                  icon={<FiCalendar />}
                  {...form.getInputProps("orderDate")}
                  disabled={isPreview}
                />
              </div>
            </div>

          </div>
        </div>
        {!isPreview && (
          <div className={classes.saveButton}>
            <Button
              id="cancel-medication"
              type="button"
              variant="subtle"
              onClick={() => {
                onclose();
                getAllPatients?.(currentPage, true, tabName);
                form?.reset();
                setRxStrengthOptions([]);
              }}
              sx={{
                background: "transparent",
                color: "#262626",
                border: "none",
                padding: "10px 18px",
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "Inter",
                "&:hover": { background: "#F5F5F5" },
              }}
            >
              Cancel
            </Button>
            <Button
              id="save-medication"
              loading={loading}
              type="submit"
              sx={{
                background: "#FFAF4A",
                border: "1px solid #FFAF4A",
                color: "#262626",
                padding: "10px 22px",
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "Inter",
                borderRadius: 8,
                boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
                transition: "background .12s ease",
                "&:hover": { background: "#EEAA33", borderColor: "#EEAA33" },
                "&[data-disabled]": { background: "#E5E5E5", borderColor: "#E5E5E5", color: "#A8A8A8", boxShadow: "none" },
              }}
            >
              Save medication
            </Button>
          </div>
        )}
      </form>

      {/* ── Webcam capture overlay ── */}
      {cameraOpen && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 2000,
          background: "rgba(0,0,0,0.85)",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16,
        }}>
          <video
            ref={(el) => {
              videoRef.current = el;
              // iOS Safari: assign srcObject + call play() the instant the element
              // is in the DOM (synchronous ref callback), before any async gaps.
              if (el && streamRef.current) {
                el.srcObject = streamRef.current;
                el.play().catch(() => {});
              }
            }}
            autoPlay
            playsInline
            muted
            style={{ width: "100%", maxWidth: 540, borderRadius: 12, background: "#000" }}
          />
          <div style={{ display: "flex", gap: 12 }}>
            <button
              type="button"
              onClick={captureFromCamera}
              style={{
                height: 44, padding: "0 28px", borderRadius: 8,
                background: "#6941C6", color: "#fff", border: "none",
                fontSize: 14, fontWeight: 600, fontFamily: "Inter", cursor: "pointer",
              }}
            >
              Capture
            </button>
            <button
              type="button"
              onClick={switchCamera}
              style={{
                height: 44, padding: "0 16px", borderRadius: 8,
                background: "transparent", color: "#fff", border: "1px solid #fff",
                fontSize: 14, fontWeight: 600, fontFamily: "Inter", cursor: "pointer",
                display: "inline-flex", alignItems: "center", gap: 6,
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 4v6h6"/><path d="M23 20v-6h-6"/>
                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
              </svg>
              Flip
            </button>
            <button
              type="button"
              onClick={closeCamera}
              style={{
                height: 44, padding: "0 28px", borderRadius: 8,
                background: "transparent", color: "#fff", border: "1px solid #fff",
                fontSize: 14, fontWeight: 600, fontFamily: "Inter", cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <ConfirmationModal
        opened={confirmModal}
        close={confirmClose}
        handleEdit={() => {
          handleEdit(true);
        }}
        // handleNewVersion={() => {
        //   handleNewVersion();
        // }}
      />
      <VersionUpdateModal
        opened={versionUpdateModal}
        close={versionUpdateClose}
        loading={loading}
        existingExpirationDate={form.values?.expirationDate}
        handleEdit={() => {
          handleUpdateThisMedication();
        }}
        handleNewVersion={(startDate, expirationDate) => {
          handleNewVersion(startDate, expirationDate);
        }}
      />
    </Drawer>
  );
};

const CustomTextInput = ({ ...rest }) => {
  const { classes } = useStyles();

  return <TextInput className={classes.inputStyle} {...rest} />;
};

const CustomSelectBox = ({ ...rest }) => {
  const { classes } = useStyles();

  return (
    <Select
      {...rest}
      rightSection={<IconChevronDown />}
      className={classes.inputStyle}
    />
  );
};

const CustomTextArea = ({ label, withAsterisk, ...rest }) => {
  const { classes } = useStyles();
  return (
    <div style={{ width: "100%" }}>
      <Textarea
        label={label}
        withAsterisk={withAsterisk}
        className={classes.inputStyle}
        {...rest}
      />
    </div>
  );
};

const stepBtnStyle = {
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  border: "1.5px solid #bbb",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  lineHeight: 1,
  flexShrink: 0,
  padding: 0,
  color: "#333",
};

const CountField = ({
  value,
  onChange,
  onDecrement,
  onIncrement,
  disabled,
  label,
  labelNode,
  error,
  withAsterisk,
}) => {
  const { classes } = useStyles();
  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <div
        style={{
          fontSize: "14px",
          fontWeight: 500,
          marginBottom: "6px",
          color: disabled ? "#aaa" : "inherit",
        }}
      >
        {labelNode || label}
        {withAsterisk && (
          <span style={{ color: "#000", marginLeft: "2px" }}>*</span>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "8px 12px",
          gap: "8px",
          border: "1px solid #E5E5E5",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <button
          type="button"
          onClick={onDecrement}
          disabled={disabled}
          style={{
            ...stepBtnStyle,
            opacity: disabled ? 0.4 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          −
        </button>
        <input
          value={value ?? ""}
          onChange={onChange}
          disabled={disabled}
          type="number"
          className={classes.noSpinner}
          placeholder={"0"}
          style={{
            flex: 1,
            border: "none",
            backgroundColor: "transparent",
            textAlign: "center",
            outline: "none",
            fontSize: "14px",
            color: disabled ? "#aaa" : "#000",
            minWidth: 0,
            borderRadius: "4px",
          }}
        />
        <button
          type="button"
          onClick={onIncrement}
          disabled={disabled}
          style={{
            ...stepBtnStyle,
            width: "30px",
            height: "30px",
            opacity: disabled ? 0.4 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          +
        </button>
      </div>
      {error && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default AddNewMedicationModal;
